import { render } from "./SearchBar.vue?vue&type=template&id=ae2fc090&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=ae2fc090&scoped=true&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2fc090"]])

export default __exports__